import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import VuetifyConfirm from 'vuetify-confirm'
import '@/plugins/veeValidate'
import '@/extensions/StringextEnsions'

Vue.config.productionTip = false

Vue.use(VuetifyConfirm, { vuetify })

/** ショートカットキー */
// eslint-disable-next-line
Vue.use(require('vue-shortkey'), { prevent: ['textarea'] })

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
